"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeHelper = void 0;
const typeChecker = __importStar(require("type-check"));
const primitive_type_enum_1 = require("./primitive-type.enum");
const typeCheck = typeChecker.typeCheck;
class TypeHelper {
    static isNil(value) {
        const is = typeCheck(`${primitive_type_enum_1.PrimitiveTypeEnum.null} | ${primitive_type_enum_1.PrimitiveTypeEnum.undefined}`, value);
        return is;
    }
    static isString(value) {
        const is = typeCheck(primitive_type_enum_1.PrimitiveTypeEnum.string, value);
        return is;
    }
    static isNumber(value) {
        const is = typeCheck(primitive_type_enum_1.PrimitiveTypeEnum.number, value);
        return is;
    }
    static isBoolean(value) {
        const is = typeCheck(primitive_type_enum_1.PrimitiveTypeEnum.boolean, value);
        return is;
    }
    static isPrimitiveTypes(value, ...types) {
        const condition = types.join(' | ');
        const is = typeCheck(condition, value);
        return is;
    }
    static isObject(value) {
        const is = typeCheck(ComplexTypeEnum.object, value);
        return is;
    }
    static isEmptyObject(value) {
        const is = this.isObject(value) && Object.keys(value).length === 0;
        return is;
    }
    static isArray(value) {
        const is = typeCheck(ComplexTypeEnum.array, value);
        return is;
    }
    static isEmptyArray(value) {
        const is = this.isArray(value) && value.length === 0;
        return is;
    }
    static isValidArray(value) {
        const is = this.isArray(value) && !this.isEmptyArray(value);
        return is;
    }
    static isPrimitiveTypesArray(value, ...type) {
        const condition = type.join(' | ');
        const is = typeCheck(`[${condition}]`, value);
        return is;
    }
    static isGivenType(value, type, options) {
        const is = typeCheck(type, value, options);
        return is;
    }
}
exports.TypeHelper = TypeHelper;
//# sourceMappingURL=type-helper.js.map